<div class="textarea-field" style="position: relative">
  <fieldset [class.disabled]="disabled" class="text-area-fieldset">
    <textarea [placeholder]="placeholder"
              (pointerdown)="onPointerDown()"
              (focus)="onFocus($event)"
              [disabled]="disabled"
              [ngModel]="value"
              (ngModelChange)="handleMainValueChange($event)"
              (blur)="onBlur()"
              [name]="label"
              [required]="required"
              [style.resize]="resize"
              autocomplete="off"
              #nativeTextArea>
    </textarea>
    @if(includePopout){<button type="button" [attr.tabindex]="popoutTabIndex" class="open-full-icon" mat-icon-button (click)="openPopout()"><mat-icon>open_in_full</mat-icon></button>}
    <legend>{{ label }}</legend>
  </fieldset>

  <div class="textarea-actions" *ngIf="includeSave || includePopout">

    <button *ngIf="includeSave"
            type="button"
            mat-button
            [ngClass]="buttonClass"
            class="textarea-action-btn"
            (click)="onSaveClicked()">
      {{ buttonLabel }}
    </button>
  </div>

  <div class="textarea-popout-backdrop"
       *ngIf="popoutOpen"
       (click)="closePopout()">

    <div class="textarea-popout"
         (click)="$event.stopPropagation()">

      <div class="textarea-popout-header">
        <div class="textarea-popout-title">
          {{ popoutTitle || label || 'Text Editor' }}
        </div>

        <button type="button"
                class="textarea-popout-close"
                (click)="closePopout()">
          ×
        </button>
      </div>

      <div class="textarea-popout-body">
        <textarea #popoutTextArea
                  [(ngModel)]="popoutValue"
                  [readonly]="popoutReadonly || disabled"
                  [placeholder]="placeholder"
                  (blur)="onBlur()"
                  class="textarea-popout-editor">
        </textarea>
      </div>

      <div class="textarea-popout-footer">
        <button type="button"
                mat-button
                class="btn-bg-red"
                (click)="closePopout()">
          Cancel
        </button>

        <button type="button"
                mat-button
                class="btn-bg-green"
                (click)="applyPopoutValue()"
                [disabled]="popoutReadonly || disabled">
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
